import { render, staticRenderFns } from "./ContentLoaderBookingMessage.vue?vue&type=template&id=a6c699b4&"
import script from "./ContentLoaderBookingMessage.vue?vue&type=script&lang=js&"
export * from "./ContentLoaderBookingMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports